/**
 * Formats a list of references to show the first item and a counter for the rest
 * @param {Array<string>} items - List of items to format
 * @returns {string} - Formatted string (e.g., "Item1 (+2)")
 */
export const formatReference = (items) => {
  if (!items || items.length === 0) return '-'
  const first = items[0]
  const count = items.length
  return count > 1 ? `${first} (+${count - 1})` : first
}

/**
 * Obtains derived colors from the theme for the widget
 * @param {object} theme - MUI theme object
 * @returns {object} - Processed color object
 */
export const getWidgetColors = (theme) => ({
  bgDark: theme.palette.background.color_212121,
  bgMedium: theme.palette.background.paper,
  textLight: theme.palette.secondary.main,
  textGrey: theme.palette.background.white,
  green: theme.palette.background.green,
  greenLight: theme.palette.primary.main,
  greenBg: theme.palette.background.table_row_hover,
  badgeBg: theme.palette.background.chip,
  border: theme.palette.background.button,
  blackAlpha: (opacity) => `rgba(0, 0, 0, ${opacity})`,
  whiteAlpha: (opacity) => `rgba(255, 255, 255, ${opacity})`
})
